import { render, staticRenderFns } from "./IndexManager.vue?vue&type=template&id=18a85c41&scoped=true"
import script from "./IndexManager.vue?vue&type=script&lang=js"
export * from "./IndexManager.vue?vue&type=script&lang=js"
import style0 from "./IndexManager.vue?vue&type=style&index=0&id=18a85c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a85c41",
  null
  
)

export default component.exports